<template>
    <div>
        <b-tabs justified pills card size="sm">
            <b-tab :disabled="step !== 0">
                <b-form ref="form" @submit="getCardInfo" class="cardform">
                    <h5 v-if="cart.length === 0">{{localized_text[lang].select_text}}</h5>
                    <b-container v-else fluid>
                        <b-row class="header" no-gutters>
                            <b-col>{{localized_text[lang].item}}</b-col>
                            <b-col cols="*">{{localized_text[lang].price}}</b-col>
                        </b-row>
                        <b-row>
                            <b-col><hr></b-col>
                        </b-row>
                        <b-row v-for="art in cart" :key="art.id" class="" no-gutters>
                            <b-col>
                                <span>{{art.tour.Title}}</span>
                                <br>
                                <span class="date" >{{art.time}}</span>
                            </b-col>
                            <b-col cols="*" class="price">
                                {{art.tour.price | formatCurrency}}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col><hr></b-col>
                        </b-row>
                        <b-row no-gutters>
                            <b-col class="header">{{localized_text[lang].tax}}</b-col>
                            <b-col cols="*" class="price">{{Total | formatCurrencyIVA(22)}}</b-col>
                        </b-row>
                        <b-row no-gutters>
                            <b-col class="header">{{localized_text[lang].total}}</b-col>
                            <b-col cols="*" class="price">{{Total | formatCurrency}}</b-col>
                        </b-row>
                        <b-row>
                            <b-col><hr></b-col>
                        </b-row>
                    </b-container>
                    <b-button v-if="cart.length > 0" type="submit" variant="success" size="sm">{{localized_text[lang].button_next}}</b-button>
                </b-form>
                <template v-slot:title>
                    {{localized_text[lang].select}} <b-icon-check v-if="gotticket"></b-icon-check>
                </template>
            </b-tab>
            <b-tab :disabled="step !== 1" >
                <h5>{{localized_text[lang].user_text}}</h5>
                <b-form @submit="goToCheckout" @reset="resetForm" class="cardform">
                    <b-form-group
                            :state="nameState"
                            invalid-feedback="Inserisci il nome"
                    >
                        <b-input-group>
                            <b-input-group-text><b-icon-person></b-icon-person></b-input-group-text>
                            <b-form-input
                                    v-model="name"
                                    :state="nameState"
                                    type="text"
                                    :placeholder="localized_text[lang].name"
                                    required
                            ></b-form-input>
                        </b-input-group>
                    </b-form-group>

                    <b-form-group
                            :state="mailState"
                            invalid-feedback="Inserisci l'email"
                    >
                        <b-input-group>
                            <b-input-group-text><b-icon-at></b-icon-at></b-input-group-text>
                            <b-form-input
                                    v-model="mail"
                                    :state="mailState"
                                    type="email"
                                    placeholder="Email"
                                    default="asd@asd.asd"
                                    required
                            ></b-form-input>
                        </b-input-group>
                    </b-form-group>
                    <h5>{{localized_text[lang].payselect_text}}</h5>
                    <b-card-header header-tag="header" role="tab" class="payheader">
                        <b-button block v-b-toggle.accordion-1 variant="light">Coupon</b-button>
                    </b-card-header>
                    <b-collapse id="accordion-1" accordion="my-accordion" v-model="pay_by_coupon" role="tabpanel">
                        <b-card-body>
                            <b-form-group :state="couponState" invalid-feedback="Coupon non valido">
                                <b-input-group>
                                    <b-input-group-text><b-icon-tag></b-icon-tag></b-input-group-text>
                                    <b-form-input
                                            v-model="coupon"
                                            :state="couponState"
                                            type="text"
                                            placeholder="Coupon"
                                    ></b-form-input>
                                </b-input-group>
                            </b-form-group>
                        </b-card-body>
                    </b-collapse>

                    <b-card-header header-tag="header" role="tab" class="payheader">
                        <b-button block v-b-toggle.accordion-2 variant="light">{{localized_text[lang].creditcard}}</b-button>
                    </b-card-header>
                    <b-collapse id="accordion-2" accordion="my-accordion" v-model="pay_by_cc" role="tabpanel">
                        <b-card-body>
                            <b-form-group>
                                <b-form-input
                                        v-model="card_name"
                                        type="text"
                                        :placeholder="localized_text[lang].cardholder"
                                        default="john doe"
                                ></b-form-input>
                            </b-form-group>
                            <div ref="card" class="card_input"></div>
                        </b-card-body>
                    </b-collapse>
                    <br>
                    <b-button-toolbar justify>
                        <b-button type="reset" variant="danger" size="sm">{{localized_text[lang].button_prev}}</b-button>
                        <b-button type="submit" variant="success" size="sm">{{localized_text[lang].button_next}}</b-button>
                    </b-button-toolbar>
                </b-form>

                <template v-slot:title>
                    {{localized_text[lang].pay}} <b-icon-check v-if="canpay"></b-icon-check>
                </template>
            </b-tab>
            <b-tab :disabled="step !== 2">
                <b-form @submit="purchase" @reset="resetForm" class="cardform">
                    <h5>{{localized_text[lang].review_text}}</h5>
                    <b-container fluid>
                        <b-row>
                            <b-col><hr></b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <div ><b-icon-person></b-icon-person>: {{name}}</div>
                                <div ><b-icon-at></b-icon-at>: {{mail}}</div>
                                <div v-if="card_name"><b-icon-credit-card></b-icon-credit-card>: {{card_name}}</div>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col><hr></b-col>
                        </b-row>
                        <b-row class="header" no-gutters>
                            <b-col>{{localized_text[lang].item}}</b-col>
                            <b-col cols="*">{{localized_text[lang].price}}</b-col>
                        </b-row>
                        <b-row>
                            <b-col><hr></b-col>
                        </b-row>
                        <b-row v-for="art in cart" :key="art.id" class="" no-gutters>
                            <b-col>
                                <span>{{art.tour.Title}}</span>
                                <br>
                                <span class="date" >{{art.time}}</span>
                            </b-col>
                            <b-col cols="*" class="price">
                                {{art.tour.price | formatCurrency}}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col><hr></b-col>
                        </b-row>
                        <b-row no-gutters>
                            <b-col class="header">{{localized_text[lang].tax}}</b-col>
                            <b-col cols="*" class="price">{{Total | formatCurrencyIVA(22)}}</b-col>
                        </b-row>
                        <b-row no-gutters>
                            <b-col class="header">{{localized_text[lang].total}}</b-col>
                            <b-col cols="*" class="price">{{Total | formatCurrency}}</b-col>
                        </b-row>
                        <b-row>
                            <b-col><hr></b-col>
                        </b-row>
                    </b-container>
                    <b-button-toolbar justify>
                        <b-button type="reset" variant="danger" size="sm">{{localized_text[lang].button_prev}}</b-button>
                        <b-button type="submit" variant="success" size="sm">{{localized_text[lang].button_buy}}</b-button>
                    </b-button-toolbar>
                </b-form>

                <template v-slot:title>
                    {{localized_text[lang].review}} <b-icon-check v-if="confirm"></b-icon-check>
                </template>
            </b-tab>
            <b-tab :disabled="step !== 3">
                <div v-if="paymentok">
                    <h5>{{localized_text[lang].success}}</h5>
                    <h2><b-icon-check variant="success"></b-icon-check></h2>
                </div>
                <div v-else-if="payerror">
                    <b-form @reset="resetForm">
                        <h5>{{localized_text[lang].error}}: {{payerror}}</h5>
                        <h2><b-icon-x variant="danger"></b-icon-x></h2>
                        <b-button-toolbar justify>
                            <b-button type="reset" variant="danger" size="sm">{{localized_text[lang].button_prev}}</b-button>
                        </b-button-toolbar>
                    </b-form>
                </div>
                <div v-else>
                    <h5>{{localized_text[lang].waiting}}</h5>
                    <h2><b-spinner></b-spinner></h2>
                </div>

                <template v-slot:title>
                    {{localized_text[lang].confirm}} <b-icon-check v-if="paymentok"></b-icon-check>
                </template>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>

    import moment from "moment";
    moment.locale('IT');

    export default {
        name: "StripeCard",
        props:['lang'],
        data () {
            return {
                name: 'john doe',
                mail: 'asd@asd.asd',
                coupon: '',
                card_name: 'john doe',
                couponState: null,
                nameState: null,
                mailState: null,
                pay_by_cc: false,
                pay_by_coupon: false,
                cart: [],
                gotticket: false,
                canpay: false,
                confirm: false,
                paymentok: false,
                payerror: null,
                step: 0,
                Stripe: null,
                stripe: null,
                card: undefined,
                hasCardErrors: false,
                style: {
                    base: {
                        border: '1px solid #D8D8D8',
                        borderRadius: '4px',
                        color: "#000",
                    },
                    invalid: {
                        // All of the error styles go inside of here.
                    }
                },
                localized_text:{
                    IT:{select:'Selezione', pay:'Pagamento', review:'Riepilogo', confirm:'Conferma',
                        select_text:'Aggiungi un biglietto per continuare', creditcard:"Carta di Credito",
                        button_next:"Prosegui", button_prev:"Indietro", button_buy:"Acquista",
                        user_text:'Inserisci nome ed email', payselect_text:"Scegli un metodo di pagamento",
                        review_text:"Verifica i dati e completa l'acquisto", cardholder:"Intestatario carta", name:"Nome",
                        waiting:"In attesa di conferma", success:"Acquisto avvenuto con successo", error:"Errore",
                        price:"Prezzo", item:"Articolo", total: "Totale", tax:"IVA"
                    },
                    EN:{select:'Select', pay:'Payment', review:'Review', confirm:'Confirm',
                        select_text:'Add a ticket to continue', creditcard:"Credit Card",
                        button_next:"Next", button_prev:"Prev", button_buy:"Buy",
                        user_text:'Insert name and email', payselect_text:"Select a payment method",
                        review_text:"Verify data and finish", cardholder:"Card holder", name:"Name",
                        waiting:"Waiting for payment", success:"Payment successful", error:"Error",
                        price:"Price", item:"Item", total: "Total", tax:"TAX"
                    }
                }
            }
        },
        computed: {
            Total() {
                let total = 0;
                this.cart.forEach(item => {
                    total += (item.tour.price);
                });
                return total;
            }
        },
        methods:{
            addToCart: function(_element) {
                this.cart.push(_element);
                this.resetForm();
            },
            setCart: function(_element) {
                this.cart = [_element];
                this.resetForm();
            },
            getCardInfo: function() {
                this.step = 1;
                this.gotticket = true;
            },
            goToCheckout: function() {
                let self = this;
                if(this.pay_by_cc){
                    this.stripe.createToken(this.card).then(function(result) {
                        // Access the token with result.token
                        if (result.error) {
                            self.hasCardErrors = true;
                            self.$forceUpdate(); // Forcing the DOM to update so the Stripe Element can update.
                        } else {
                            self.step = 2;
                            self.canpay = true;
                            self.payerror = null;
                        }
                    })
                }
            },
            resetForm: function() {
                this.step = 0;
                this.gotticket = false;
                this.canpay = false;
                this.confirm = false;
                this.paymentok = false;
                this.payerror = null;
            },
            purchase: function () {
                let self = this;

                self.confirm = true;
                self.step = 3;

                if(self.pay_by_cc) {
                    let stripe = self.$firebase.functions.httpsCallable('getStripe');
                    stripe({tour_id: self.cart[0].tour.ID, receipt_email:self.mail}).then(function(response) {
                        self.stripe.confirmCardPayment(response.data.client_secret, {
                            payment_method: {
                                card: self.card,
                                billing_details: {
                                    name: self.card_name
                                }
                            }
                        }).then(function(result) {
                            if (result.error) {
                                self.payerror = result.error.message;
                                self.$emit('purchase-failed', response.data.t_ref);
                            } else {
                                // The payment has been processed!
                                if (result.paymentIntent.status === 'succeeded') {
                                    console.log(result.paymentIntent);
                                    self.paymentok = true;
                                    let price = self.formatEuro(result.paymentIntent.amount);
                                    let price_tax = self.formatEuro(result.paymentIntent.amount, 22);
                                    self.$emit('purchase-success', {
                                        ref: response.data.t_ref,
                                        name: self.name,
                                        mail: self.mail,
                                        tckt_tax: price_tax,
                                        tckt_price: price,
                                        purch_date: moment.unix(result.paymentIntent.created).format('LLL'),
                                        tckt_date: self.cart[0].time,
                                        user_cardname: self.card_name
                                    });
                                } else {
                                    self.$emit('purchase-failed', response.data.t_ref);
                                }
                            }
                        });
                    });
                } else {
                    console.log('pay by coupon');
                }
            },
            formatEuro: function (_value, _rate=null) {
                let formatter = new Intl.NumberFormat('it-IT', {
                    style: 'currency',
                    currency: 'EUR',
                });

                if(_rate){
                    return formatter.format((_value / 100) * (_rate * 0.01));
                } else {
                    return formatter.format((_value / 100));
                }
            },
            loadStripe(){
                const style = {
                    hidePostalCode : true,
                    base: {
                        color: '#31325f',
                        fontSmoothing: 'antialiased',
                        fontSize: '16px',
                        '::placeholder': {
                            color: '#aab7c4',
                        },
                        ':-webkit-autofill': {
                            color: '#666ee8',
                        },
                    },
                };
                clearInterval(this.checkingInterval);
                // Live key
                // this.stripe = window.Stripe(`pk_live_51Hj05BArxHPShFXJ1HeYdBhga7TvWYPZfEFx14H0a062HaIDzZccuvAStDjdVeE0af84zZadFtBzTjqEdq8A86lp00cuPHrN9f`);
                this.stripe = window.Stripe('pk_test_51Hj05BArxHPShFXJS9ZGweCxL5ta93EzZ2OwsDjLCDGg79XA37Z5NDMY5crleZHq2sFYeeInKP2yAfyHbKaPs4nl00pH75FhP4');
                let elements = this.stripe.elements();
                this.card = elements.create('card', {style});
                this.card.mount(this.$refs.card);
            }

        },
        filters:{
            formatCurrency: function (_value) {
                let formatter = new Intl.NumberFormat('it-IT', {
                    style: 'currency',
                    currency: 'EUR',
                });
                return formatter.format((_value / 100));
            },
            formatCurrencyIVA: function (_value, _rate) {
                let formatter = new Intl.NumberFormat('it-IT', {
                    style: 'currency',
                    currency: 'EUR',
                });
                return formatter.format((_value / 100) * (_rate * 0.01));
            }
        },
        created: function (){
            if(!this.Stripe){
                this.Stripe = document.createElement('script');
                this.Stripe.setAttribute('src',"https://js.stripe.com/v3/");
                this.Stripe.setAttribute('type',"text/javascript");
                document.head.appendChild(this.Stripe);
            }

            this.checkingInterval = setInterval(function(){
                if (window.Stripe) {
                    this.loadStripe();
                }
            }.bind(this), 500) //or whatever interval you want to check
        },
        mounted: function () {
            this.$nextTick(() => {
            })
        }
    };
</script>

<style scoped>

    .card_input{
        margin-top:10px;
        display: block;
        width: 100%;
        height: calc(1.5em + 0.75rem + 2px);
        padding: 0.375rem 0.75rem;
        font-size: 1rem;
        font-weight: 400;
        line-height: 1.5;
        color: #495057;
        background-color: #fff;
        background-clip: padding-box;
        border: 1px solid #ced4da;
        border-radius: 0.25rem;
    }

    .cardform{
        margin:0 auto;
        text-align: initial;
    }

    .payheader{
        max-height:40px;
        padding: 0;
    }

    .header{
        font-size:0.8em;
        font-style: italic;
    }

    .price{
        font-size:0.8em !important;
        font-weight: bold;
    }

    .date{
        font-size:0.95em;
        font-style: italic;
    }

    @media screen and (max-width: 400px) {

        .card-body{
            /*font-size: 0.9em;*/
            padding: 0.7em;
        }
    }

</style>
